export default "__VITE_ASSET__BSntl0Qh__"